import Marty from "marty";

const AUTH_CONSTANTS = Marty.createConstants([
    "AUTH_LOGIN",
    "AUTH_LOGOUT"
]);

export default AUTH_CONSTANTS;



/** WEBPACK FOOTER **
 ** ./app/constants/authConstants.js
 **/